import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatError, MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

@Component({
  selector: 'sbd-account-portal-frontend-payment',
  standalone: true,
  imports: [CommonModule, FormsModule, MatAutocompleteTrigger, MatFormField, MatIcon, MatInput, MatPrefix, MatError, MatLabel, ReactiveFormsModule, SharedComponentsModule, MatRadioGroup, MatRadioButton],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
})
export class PaymentComponent implements OnInit {
  @Input() formGroup: FormGroup;

  ngOnInit(): void {
   /* this.formGroup?.get('credit_card_number').valueChanges.subscribe((value) => {
      this.validateCardNumber();
    });*/
  }

  get creditCardNumberControl() {
    return this.formGroup.get('selectedCardType');
  }


  // Function to validate card number and set the card type
  validateCardNumber(): { [key: string]: boolean } | null {
    const value = this.formGroup.get('credit_card_number').value;
    if (!value) {
      this.formGroup?.get('selectedCardType').setValue('');
      return null;
    }

    // Regex patterns for card types
    const visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;
    const mastercardRegex = /^5[1-5][0-9]{14}$/;
    const amexRegex = /^3[47][0-9]{13}$/;

    if (visaRegex.test(value)) {
      this.formGroup.get('selectedCardType').setValue('visa');
      return null;
    } else if (mastercardRegex.test(value)) {
      this.formGroup.get('selectedCardType').setValue('mastercard');
      return null;
    } else if (amexRegex.test(value)) {
      this.formGroup.get('selectedCardType').setValue('amex');
      return null;
    } else {
      this.formGroup.get('selectedCardType').setValue(''); // No valid card type
      return { invalidCard: true };
    }
  }
}
